import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { type LWApiPublicUtilitiesInfoWhatismyipResultsRaw } from '@liquidweb-dev/club-sauce/public/utilities/info/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import apiBasicAuth from 'modules/queries/apiBasicAuth';

export const UTILITIES_INFO_WHATISMYIP_QUERY_KEY = '/utilities/info/whatismyip';

/**
 * Always uses basic auth as some user types ("kero-only") are restricted from this endpoint for some reason
 */
const useWhatismyip = (
	options?: UseQueryOptions<
		LWApiPublicUtilitiesInfoWhatismyipResultsRaw,
		ApiErrorI
	>,
) => {
	return useQuery({
		queryKey: [UTILITIES_INFO_WHATISMYIP_QUERY_KEY],
		queryFn: () => apiBasicAuth.utilities.info.apiRaw.whatismyip(),
		...options,
	});
};

export default useWhatismyip;
